/*
 * @Description:
 * @Author: 赵大壮
 * @Date: 2021-11-25 13:05:57
 * @LastEditTime: 2022-05-23 18:11:29
 * @LastEditors: 赵大壮
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store';
import "./router/permission"

import './plugins/element.js';
import "./style/tailwindcss.css"
import './style/index.less';
import './style/iconfont/iconfont.css'
import '@/style/iconfont/iconfont'
import DZModelSystemConfig from './model/DZModelSystemConfig';

// 动态修改浏览器标题
document.title = process.env.VUE_APP_ProjectName;

// 扩展
import '@/extension/nyString.extensions'

// echarts
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

// 公共Model
Vue.prototype.$dzSystem = new DZModelSystemConfig();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
